import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { ROUTES } from 'config';
import {
  ActionsMenu,
  Link,
  ListTotal,
  Table,
  TableToolbar,
  TableWrapper,
  Typography,
} from 'melp-design/components';
import { useRouteParams } from 'utils/useIdParam';
import { useHistory } from 'react-router-dom';
import { useAdminCompanies } from 'store/admin-companies';
import { COLOR_BY_STATUS } from 'store/companies';

export const ClientCompaniesList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id: clientId } = useRouteParams(
    ROUTES.admin.clients.details.companies.list,
  );

  const { data: companies, isLoading } = useAdminCompanies(clientId);

  return (
    <TableWrapper>
      <TableToolbar>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <ListTotal total={companies?.total} />
        </Stack>
      </TableToolbar>

      <Table
        data={companies?.items ?? []}
        isLoading={isLoading}
        columns={[
          {
            id: 'name',
            header: t('companies.company_name'),
            cell: ({ row: { original: company } }) => {
              return (
                <Link
                  label={company.name}
                  to={ROUTES.admin.clients.details.companies.details
                    .replace(':id', clientId)
                    .replace(':companyId', company.id)}
                />
              );
            },
          },
          {
            id: 'code',
            header: t('companies.company_code'),
            cell: ({ row: { original: company } }) => {
              return company.code;
            },
          },
          {
            id: 'status',
            header: t('common.status'),
            cell: ({ row: { original: company } }) => {
              return (
                <Typography color={COLOR_BY_STATUS[company.status]}>
                  {t(`status.${company.status}`)}
                </Typography>
              );
            },
          },
          {
            id: 'actions',
            cell: ({ row: { original: company } }) => {
              return (
                <ActionsMenu
                  type="compact"
                  items={[
                    {
                      label: t('common.edit'),
                      onClick: () => {
                        history.push(
                          ROUTES.admin.clients.details.companies.details
                            .replace(':id', clientId)
                            .replace(':companyId', company.id),
                        );
                      },
                    },
                  ]}
                />
              );
            },
            meta: { align: 'right' },
          },
        ]}
      />
    </TableWrapper>
  );
};
